import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import Basic from '../Components/Basic/Basic';
import Rightside from './Customer/Rightside';
import activeStatus from '../assets/caprock/status/active.svg';
import pendingStatus from '../assets/caprock/status/pending.svg';
import rejectStatus from '../assets/caprock/status/reject.svg';
import moment from 'moment';
import './Documents.css';

const Documents = () => {
  const navigate = useNavigate();
  const STORAGE_KEY = "caprock-local";
  const systemToken = localStorage.getItem('systemToken') || "";
  
  // State variables
  
  // const [token, setToken] = useState(''); 
  const [docs, setDocs] = useState([]);
  const [localStorageData, setLocalStorageData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
   
  const [timer, setTimer] = useState(undefined);
  const [showSendingEmailModal, setShowSendingEmailModal] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // Add this line
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const buttonRefs = useRef({});

  // Check authentication on component mount
  useEffect(() => {
    
    document.title = "My Documents || Caprock Merchant Platform";
    localStorage.setItem('active_page', 'documents');
  }, [navigate]);

  useEffect(() => {  
      getDocuments(''); 
  }, [localStorageData]); // Fixed dependency

  // Add this useEffect to handle clicking outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdown !== null && !event.target.closest('.dropdown-container')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [openDropdown]);

  const openLink = (id) => {
    const link = document.getElementById("URL" + id)?.value;
    if (link) {
      window.open(link, '_blank');
    }
  }; 
 

  const getDocuments = async (search) => {
    setIsLoading(true);
    try {
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      const formData = new FormData();

      
      formData.append("user_token", systemToken);
      console.log('localstorage data', systemToken);
      formData.append("search", search || "");
  
      const response = await fetch(`${Base_url}/customer-docs`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorageData['access-token']}`, // Updated variable name
        },
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success === 200) {
          const sdocs = data.docs;
          for (let i = 0; i < sdocs.length; i++) {
            sdocs[i]['doc_time'] = moment(sdocs[i]['created_at']).format('DD MMM, YYYY');
          }
          setDocs(sdocs);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const textSearch = (e) => {
    setIsLoading(true);
    setDocs([]); // Clear previous results immediately
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      getDocuments(e.target.value);
    }, 300);
    setTimer(newTimer);
  };

  const mailDoc = async (docId, to, type) => {
    return false;
    setShowSendingEmailModal(true);
    
    if (parseInt(docId) === 0 || docId === '') {
      alert('Please select valid document from list');
      setShowSendingEmailModal(false);
      return false;
    }

    const formData = new FormData();
    formData.append('device', 'react');
    formData.append('user_token', systemToken);
    formData.append('doc_id', docId);
    formData.append('to', '1');
    formData.append('ttype', 'doc');

    try {
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      const url = Base_url + 'send-doc-mail';
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      }); 
      const data = await response.json();
      setShowSendingEmailModal(false); 
      if (data.success === 200) {
        alert(data.message);
      } else {
        alert(data.message);
      }
    } catch (error) {
      setShowSendingEmailModal(false);
      console.error('Error sending document:', error);
    }
  };

  return (
    <>
      <Basic />
      
      <div className="main-content w-full">
        <section className="section w-full">
          {/* Header Section */}
          <div className="w-full px-6 py-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible">
              {/* Header */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-6 border-b border-gray-100">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold text-gray-900">My Documents</h1>
                      <p className="text-sm text-gray-600 mt-1">Manage and access your uploaded documents</p>
                    </div>
                  </div>
                  
                  {/* Search Bar */}
                  <div className="relative lg:w-80">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input 
                      onChange={textSearch}
                      type="text"   
                      id="doc_search_input" 
                      placeholder="Search documents..." 
                      className="block w-full pl-11 pr-4 py-2.5 border border-gray-200 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    />
                  </div>
                </div>
              </div>
              
              {/* Table Header */}
              <div className="bg-gray-50 px-6 py-4 border-b border-gray-100">
                <div className="grid grid-cols-12 gap-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  <div className="col-span-3">ID & Status</div>
                  <div className="col-span-4">Document Name</div>
                  <div className="col-span-3">Date Added</div>
                  <div className="col-span-2 text-center">Actions</div>
                </div>
              </div>
              
              {/* Documents List */}
              <div className="divide-y divide-gray-100 relative">
                {isLoading ? (
                  <div className="px-6 py-16 text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                      <div className="w-8 h-8 border-2 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Loading documents...</h3>
                    <p className="text-gray-500">Please wait while we fetch your documents.</p>
                  </div>
                ) : docs.length > 0 ? (
                  docs.map((doc, index) => (
                    <div key={doc.doc_id} className="px-6 py-4 hover:bg-gray-50 transition-colors duration-200">
                      <div className="grid grid-cols-12 gap-4 items-center">
                        {/* ID & Status */}
                        <div className="col-span-3">
                          <div className="flex items-center gap-2 ml-2">
                            {/* Status Indicator */}
                            <div className="w-2 h-2 rounded-full flex-shrink-0">
                              {doc.doc_status === 'Approved' && (
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                              )}
                              {doc.doc_status === 'Pending' && (
                                <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                              )}
                              {doc.doc_status === 'Rejected' && (
                                <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                              )}
                            </div>
                            <span className="text-sm font-medium text-gray-700 flex-shrink-0">#{doc.doc_id || 'N/A'}</span>
                            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ml-1 ${
                              doc.doc_status === 'Approved' 
                                ? 'bg-green-100 text-green-800' 
                                : doc.doc_status === 'Pending'
                                ? 'bg-yellow-100 text-yellow-800'
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {doc.doc_status || 'N/A'}
                            </span>
                          </div>
                        </div>
                        
                        {/* Document Name */}
                        <div className="col-span-4">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            <span className="text-sm font-medium text-gray-900 truncate">{doc.doc_name || 'N/A'}</span>
                          </div>
                        </div>
                        
                        {/* Date Added */}
                        <div className="col-span-3">
                          <span className="text-sm text-gray-600">{doc.doc_time || 'N/A'}</span>
                        </div>
                        
                        {/* Actions */}
                        <div className="col-span-2">
                          <div className="flex justify-center">
                            <div className="relative dropdown-container">
                              <input 
                                id={`URL${doc.doc_id}`}
                                type="hidden" 
                                value={doc.doc_url || ''}
                              />
                              <button 
                                ref={(el) => buttonRefs.current[index] = el}
                                className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (openDropdown === index) {
                                    setOpenDropdown(null);
                                  } else {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setDropdownPosition({
                                      top: rect.bottom + window.scrollY + 4,
                                      left: rect.right + window.scrollX - 192
                                    });
                                    setOpenDropdown(index);
                                  }
                                }}
                                type="button"
                                data-index={index}
                              > 
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                  <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>
                              </button>
                              

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="px-6 py-16 text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">No documents found</h3>
                    <p className="text-gray-500 mb-4">We couldn't find any documents matching your search criteria.</p>
                    <p className="text-sm text-gray-400">Try adjusting your search terms or check back later for new uploads.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Sending Email Modal */}
      {showSendingEmailModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 transform transition-all duration-300 scale-100">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-8 h-8 text-blue-600 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Sending Document</h3>
              <p className="text-gray-600">Please wait while we send the document to your email...</p>
              
              {/* Loading Animation */}
              <div className="mt-6">
                <div className="flex justify-center">
                  <div className="w-6 h-6 border-2 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Portal-based Dropdown */}
      {openDropdown !== null && createPortal(
        <div 
          className="fixed bg-white rounded-lg shadow-xl border border-gray-200 py-1 z-[9999] w-48"
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`
          }}
        >
          <button
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors duration-200"
            onClick={(e) => {
              e.stopPropagation();
              const doc = docs[openDropdown];
              openLink(doc.doc_id);
              setOpenDropdown(null);
            }}
          > 
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download
          </button>
          <button
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-colors duration-200"
            onClick={(e) => {
              e.stopPropagation();
              const doc = docs[openDropdown];
              mailDoc(doc.doc_id, 1, 'doc');
              setOpenDropdown(null);
            }}
          > 
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Send Email
          </button>
        </div>,
        document.body
      )}
    </>
  );
};

export default Documents;
